import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { PageSchema } from '@/components/SEOSchema';
import { SITE_URL } from '@/lib/seo';

export default function PrivacyPage() {
  const { t, i18n } = useTranslation();
  const homePath = i18n.language === 'pt' ? '/' : `/${i18n.language}/`;
  const privacyUrl = `${SITE_URL}${i18n.language === 'pt' ? '/privacy/' : i18n.language === 'de' ? '/de/datenschutz/' : '/en/privacy/'}`;

  return (
    <div className="min-h-screen bg-background-50">
      <PageSchema
        type="WebPage"
        name={t('footer.privacy')}
        description="Read the privacy policy of the CSSBuy Spreadsheet Resource Hub, including data collection, cookies and external links."
        url={privacyUrl}
        lang={i18n.language}
      />
      <Navbar />

      <div className="w-full px-4 md:px-6 lg:px-10 pt-24 pb-16">
        <div className="max-w-3xl mx-auto">
          <nav className="flex items-center gap-2 text-sm text-foreground-400 mb-6">
            <Link to={homePath} className="hover:text-primary-600 transition-colors">{t('nav.home')}</Link>
            <i className="ri-arrow-right-s-line text-xs" />
            <span className="text-foreground-600">{t('footer.privacy')}</span>
          </nav>

          <h1 className="text-3xl md:text-4xl font-semibold mb-8">{t('footer.privacy')}</h1>

          <div className="prose max-w-none space-y-6">
            <div className="bg-white border border-background-200/60 rounded-xl p-6">
              <h2 className="text-xl font-semibold mb-3">Information We Collect</h2>
              <p className="text-foreground-600 text-sm leading-relaxed">
                cssbuybr.sbs is a static informational website. We do not collect personal data, require user registration, or process payments. We may use standard analytics tools to understand website traffic patterns, which collect anonymized data such as browser type, pages visited, and general geographic location. No personally identifiable information is collected.
              </p>
            </div>

            <div className="bg-white border border-background-200/60 rounded-xl p-6">
              <h2 className="text-xl font-semibold mb-3">Cookies</h2>
              <p className="text-foreground-600 text-sm leading-relaxed">
                We may use minimal cookies to remember your language preference and improve site functionality. These cookies do not track personal information across websites. You can disable cookies in your browser settings at any time.
              </p>
            </div>

            <div className="bg-white border border-background-200/60 rounded-xl p-6">
              <h2 className="text-xl font-semibold mb-3">External Links</h2>
              <p className="text-foreground-600 text-sm leading-relaxed">
                This website contains links to external websites, including kaspreadsheet.com and CSSBuy. We are not responsible for the privacy practices or content of these third-party websites. We recommend reviewing their privacy policies before providing any personal information.
              </p>
            </div>

            <div className="bg-white border border-background-200/60 rounded-xl p-6">
              <h2 className="text-xl font-semibold mb-3">Data Security</h2>
              <p className="text-foreground-600 text-sm leading-relaxed">
                We take reasonable precautions to protect any information processed through our website. However, no internet transmission is completely secure. We cannot guarantee the security of information transmitted to or from our website.
              </p>
            </div>

            <div className="bg-white border border-background-200/60 rounded-xl p-6">
              <h2 className="text-xl font-semibold mb-3">Changes to This Policy</h2>
              <p className="text-foreground-600 text-sm leading-relaxed">
                We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date. We encourage visitors to review this policy periodically.
              </p>
            </div>

            <div className="bg-foreground-50 border border-foreground-200/50 rounded-xl p-6">
              <p className="text-sm text-foreground-500">
                Last updated: 27 August 2026. If you have questions about this privacy policy, please contact us through our contact page.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}